import { useEffect, useRef } from "react";

export const Modal = ({ onClose, children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const d = ref.current;
    if (!d.open) d.showModal();
    return () => {
      if (d.open) d.close();
    };
  }, []);
  return (
    <dialog ref={ref} data-testid="modal" onCancel={e => { e.preventDefault(); onClose(); }}>
      <button className="close" data-testid="modal-close-btn" aria-label="Close" onClick={onClose}>✕</button>
      {children}
    </dialog>
  );
};
